var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleAddLightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428 630v109q0 22 15.5 37.5T481 792q22 0 37.5-15.5T534 739V630h109q22 0 37.5-15.5T696 577q0-22-15.5-37.5T643 524H534V413q0-22-15.5-37.5T481 360q-22 0-37.5 15.5T428 413v111H317q-22 0-37.5 15.5T264 577q0 22 15.5 37.5T317 630h111Zm52 378q-89.64 0-168.48-34.02-78.84-34.02-137.16-92.34-58.32-58.32-92.34-137.16T48 576q0-89.896 34.079-168.961 34.079-79.066 92.5-137.552Q233 211 311.738 177.5 390.476 144 480 144q89.886 0 168.943 33.5Q728 211 786.5 269.5q58.5 58.5 92 137.583 33.5 79.084 33.5 169Q912 666 878.5 744.5t-91.987 136.921q-58.486 58.421-137.552 92.5Q569.896 1008 480 1008Zm0-106q136.513 0 231.256-94.744Q806 712.513 806 576t-94.744-231.256Q616.513 250 480 250t-231.256 94.744Q154 439.487 154 576t94.744 231.256Q343.487 902 480 902Zm0-326Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAddLightIcon);
export default __webpack_public_path__ + "static/media/circleAddLightIcon.791159782a3647410995f9bd2879a802.svg";
export { ForwardRef as ReactComponent };